var map = {
	"./acrobat.png": 88035,
	"./alchemist.png": 49799,
	"./alhadikhia.png": 58723,
	"./alsaahir.png": 93393,
	"./amnesiac.png": 85118,
	"./angel.png": 16474,
	"./apprentice.png": 80819,
	"./artist.png": 46835,
	"./assassin.png": 63169,
	"./atheist.png": 946,
	"./balloonist.png": 5926,
	"./banshee.png": 18063,
	"./barber.png": 28069,
	"./barista.png": 22437,
	"./baron.png": 48230,
	"./beggar.png": 51082,
	"./bishop.png": 75343,
	"./boffin.png": 98775,
	"./bonecollector.png": 31594,
	"./boomdandy.png": 13682,
	"./bountyhunter.png": 17479,
	"./buddhist.png": 1990,
	"./bureaucrat.png": 20367,
	"./butcher.png": 80177,
	"./butler.png": 24697,
	"./cacklejack.png": 38985,
	"./cannibal.png": 76214,
	"./cerenovus.png": 97637,
	"./chambermaid.png": 31146,
	"./chef.png": 61248,
	"./choirboy.png": 55081,
	"./clockmaker.png": 65102,
	"./courtier.png": 80759,
	"./cultleader.png": 72763,
	"./custom.png": 7037,
	"./damsel.png": 85533,
	"./deusexfiasco.png": 8141,
	"./deviant.png": 91683,
	"./devilsadvocate.png": 5549,
	"./djinn.png": 60393,
	"./doomsayer.png": 25142,
	"./dreamer.png": 91610,
	"./drunk.png": 83669,
	"./duchess.png": 12491,
	"./empath.png": 65695,
	"./engineer.png": 27571,
	"./evil.png": 91836,
	"./eviltwin.png": 37664,
	"./exorcist.png": 15858,
	"./fabled.png": 5025,
	"./fanggu.png": 91833,
	"./farmer.png": 94390,
	"./fearmonger.png": 15297,
	"./ferryman.png": 50762,
	"./fibbin.png": 29332,
	"./fiddler.png": 35076,
	"./fisherman.png": 62776,
	"./flowergirl.png": 36053,
	"./fool.png": 60647,
	"./fortuneteller.png": 19336,
	"./gambler.png": 14306,
	"./gangster.png": 782,
	"./general.png": 2990,
	"./gnome.png": 82962,
	"./goblin.png": 31730,
	"./godfather.png": 78536,
	"./golem.png": 27274,
	"./good.png": 96832,
	"./goon.png": 51273,
	"./gossip.png": 95965,
	"./grandmother.png": 4950,
	"./gunslinger.png": 67768,
	"./harlot.png": 86226,
	"./harpy.png": 33865,
	"./hatter.png": 93490,
	"./hellslibrarian.png": 45477,
	"./heretic.png": 66314,
	"./hermit.png": 6004,
	"./highpriestess.png": 26251,
	"./huntsman.png": 37893,
	"./imp.png": 82830,
	"./innkeeper.png": 96580,
	"./investigator.png": 39813,
	"./judge.png": 36306,
	"./juggler.png": 38785,
	"./kazali.png": 91465,
	"./king.png": 36865,
	"./klutz.png": 81938,
	"./knight.png": 33395,
	"./legion.png": 92339,
	"./leviathan.png": 63245,
	"./librarian.png": 40651,
	"./lilmonsta.png": 4090,
	"./lleech.png": 31424,
	"./lordoftyphon.png": 76262,
	"./lunatic.png": 52561,
	"./lycanthrope.png": 68746,
	"./magician.png": 44214,
	"./marionette.png": 60712,
	"./mastermind.png": 77100,
	"./mathematician.png": 53850,
	"./matron.png": 8054,
	"./mayor.png": 48827,
	"./mephit.png": 53304,
	"./mezepheles.png": 30295,
	"./minion.png": 847,
	"./minstrel.png": 33415,
	"./monk.png": 83100,
	"./moonchild.png": 28749,
	"./mutant.png": 94473,
	"./nightwatchman.png": 92666,
	"./noble.png": 81004,
	"./nodashii.png": 62830,
	"./ogre.png": 92306,
	"./ojo.png": 43073,
	"./oracle.png": 39624,
	"./organgrinder.png": 15705,
	"./outsider.png": 68814,
	"./pacifist.png": 25873,
	"./philosopher.png": 63300,
	"./pithag.png": 91282,
	"./pixie.png": 58637,
	"./plaguedoctor.png": 25985,
	"./plus.png": 14511,
	"./po.png": 85631,
	"./poisoner.png": 26763,
	"./politician.png": 64265,
	"./poppygrower.png": 38828,
	"./preacher.png": 53213,
	"./princess.png": 28705,
	"./professor.png": 90889,
	"./psychopath.png": 27826,
	"./pukka.png": 64486,
	"./puzzlemaster.png": 27002,
	"./ravenkeeper.png": 66965,
	"./recluse.png": 93035,
	"./revolutionary.png": 19038,
	"./riot.png": 78118,
	"./sage.png": 6544,
	"./sailor.png": 48984,
	"./saint.png": 14811,
	"./savant.png": 77884,
	"./scapegoat.png": 46701,
	"./scarletwoman.png": 83957,
	"./seamstress.png": 44201,
	"./sentinel.png": 24213,
	"./shabaloth.png": 32034,
	"./shugenja.png": 60922,
	"./slayer.png": 8081,
	"./snakecharmer.png": 99900,
	"./snitch.png": 87988,
	"./soldier.png": 12231,
	"./spiritofivory.png": 93379,
	"./spy.png": 44013,
	"./steward.png": 36050,
	"./stormcatcher.png": 93877,
	"./summoner.png": 60817,
	"./sweetheart.png": 86356,
	"./tealady.png": 53009,
	"./thief.png": 67112,
	"./tinker.png": 55380,
	"./towncrier.png": 4055,
	"./toymaker.png": 3163,
	"./undertaker.png": 75466,
	"./vigormortis.png": 64969,
	"./villageidiot.png": 24883,
	"./virgin.png": 46954,
	"./vizier.png": 5485,
	"./vortox.png": 46142,
	"./voudon.png": 80152,
	"./washerwoman.png": 10245,
	"./widow.png": 76865,
	"./witch.png": 96909,
	"./wizard.png": 13264,
	"./wraith.png": 18343,
	"./x.png": 71139,
	"./xaan.png": 93505,
	"./yaggababble.png": 44520,
	"./zealot.png": 27044,
	"./zombuul.png": 48899
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16003;